import type { ApisauceInstance } from "apisauce";
import { ENQUIRY_RESUME_DOWNLOAD_ENDPOINT } from "./enquiry-settings";

const parseFilename = (header?: string) => {
    if (!header) return null;
    const match =
        header.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/i) ||
        header.match(/filename=["']?([^"';\n]+)["']?/i);
    return match ? match[1].trim() : null;
};

const readBlobError = async (blob: Blob) => {
    try {
        const text = await blob.text();
        const json = JSON.parse(text);
        return (json.detail ?? json.message ?? text) || "Download failed";
    } catch {
        return "Download failed";
    }
};

export const downloadEnquiryResume = async (
    api: ApisauceInstance,
    id: number,
    fallbackFilename: string
) => {
    const response = await api.post(
        ENQUIRY_RESUME_DOWNLOAD_ENDPOINT,
        { id },
        { responseType: "blob" }
    );

    if (!response.ok || !response.data) {
        const message =
            response.data instanceof Blob
                ? await readBlobError(response.data)
                : "Could not download resume.";
        throw new Error(message);
    }

    const blob = response.data as Blob;
    const filename =
        parseFilename(response.headers?.["content-disposition"]) ||
        parseFilename(response.headers?.["Content-Disposition"]) ||
        fallbackFilename;

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};
